import * as React from 'react';
import { Box } from '@mui/material';
import PauseRounded from '@mui/icons-material/PauseRounded';

/** The smallest touch target, in px, the button's hit area keeps. */
export const PAUSE_TOUCH_TARGET_PX = 44;

/**
 * Pause, in the tutorial video's controls, while taps are played. A tap on the
 * exercise area is a note then, so it cannot pause as a tap on the video does,
 * and touch devices have no Escape key. The paused overlay resumes, as today.
 * Drawn like the volume button beside it; its hit area is at least
 * PAUSE_TOUCH_TARGET_PX each way, grown sideways and downward from the
 * smaller visible button, never up into the exercise.
 */
export default function TapInputPauseButton({ onPause }: { onPause: () => void }) {
  return (
    <Box
      component="button"
      type="button"
      aria-label="Pause"
      onClick={onPause}
      sx={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        background: '#525969',
        color: 'white',
        padding: '1px 8px',
        border: '1px solid #525969',
        cursor: 'pointer',
        ':hover': {
          border: '1px solid white',
          background: '#333B4D',
        },
        // The hit area grows sideways and down, never up into the exercise.
        '::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: '50%',
          width: `max(100%, ${PAUSE_TOUCH_TARGET_PX}px)`,
          height: `max(100%, ${PAUSE_TOUCH_TARGET_PX}px)`,
          transform: 'translateX(-50%)',
        },
      }}
    >
      <PauseRounded fontSize="small" />
    </Box>
  );
}
